module.exports = __webpack_public_path__ + "img/pay-weixin.10716d6f.png";